/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState } from "react";
import moment from "moment-timezone";
import { connect } from "react-redux";
import Col from "../../UIcomponent/Column";
import DashboardProfile from "../../Component/Dashboard/DashboardProfile/DashboardProfile";
import DashboardSessionStatistics from "../../Component/Dashboard/DashboardSessionStatistics/DashboardSessionStatistics";
import DashboardReq from "../../Utility/Requester/DashboardReq";
import DashboardCredit from "../../Component/Dashboard/DashboardCredit/DashboardCredit";
import LocalContext from "../../Context/LocalContetxt";
import LessonsList from "../../Component/Lessons/LessonsList/LessonsList";
import { ThemeContext } from "styled-components";
import MaterialThemeProvider from "../../Component/Material/MaterialThemeProvider";
import ReviewModal from "../../Component/Dashboard/DashboardListItem/ReviewModal";
import Metas from "../../Component/Metas";
import BannerView from "../../Component/BannerView";
import DashboardReferal from "../../Component/Dashboard/DashboardReferal/DashboardReferal";
import { DashboardLayout } from "./styles";

import "./Dashboard.scss";
import actions from "../../redux/actions";

const StudentDashboard = (props) => {
  const { isFetching, sessions, fetchUpcomingSessions } = props;
  const lang = useContext(LocalContext).lang;
  const config = useContext(LocalContext).config;
  const theme = useContext(ThemeContext);

  const [DashboardState, setDashboardState] = useState({
    avatar: config ? config.avatar : "",
    firstName: config ? config.firstName : "",
    lastName: config ? config.lastName : "",
    upComming: null,
    held: null,
    nonScheduled: null,
    credit: null,
    dataTillTomorrow: [],
  });
  const [rateState, setRateState] = useState({
    open: false,
    session: null,
  });
  const [Wallet, setWallet] = useState([]);
  const [calendarClicked, setCalendarClicked] = useState(false);

  useEffect(() => {
    moment.locale("en");

    if (config && config.role) {
      moment.tz.setDefault(config.timeZone);
      fetchUpcomingSessions(config.role);

      DashboardReq.GetWallet(config.role)
        .then((res) => {
          setWallet(res.data);
        })
        .catch((err) => {});
      DashboardReq.lastSessionWithoutReview().then((res) => {
        if (res.data) {
          setRateState({
            open: true,

            session: {
              ...res.data,
              UserAvatar: res.data.TeacherAvatar,
              FirstName: res.data.TeacherFirstName,
              LastName: res.data.TeacherLastName,
              ID: res.data.TeacherUserID,
            },
          });
        }
      });
    }
  }, [config]);

  return (
    <DashboardLayout xl={18} lg={18} md={20} sm={24} xs={24}>
      <Metas
        title="داشبورد زبان آموز | لینگوتاک"
        description="داشبورد زبان آموز | لینگوتاک"
      />
      <>
        <Col
          className="w__Dashboard__Info"
          xl={24}
          lg={24}
          md={24}
          sm={24}
          xs={24}
        >
          <Col
            className="l__Dashboard__Profile"
            xl={6.5}
            lg={7.5}
            md={6.5}
            sm={24}
            xs={24}
          >
            <DashboardProfile
              credit={Wallet && Wallet.Balance}
              theme={theme}
              firstName={DashboardState.firstName}
              lastName={DashboardState.lastName}
              avatar={DashboardState.avatar}
              reviewStats={null}
            />
          </Col>
          <Col
            xl={12.5}
            lg={11}
            md={10.5}
            sm={22}
            xs={22}
            className="l__Dashboard__SessionStatistics"
          >
            {config && (
              <DashboardSessionStatistics role={config && config.role} />
            )}
          </Col>
          <Col
            xl={4.5}
            lg={5}
            md={6.5}
            sm={7}
            xs={7}
            className="l__Dashboard__Credit"
          >
            {config && <DashboardCredit credit={Wallet && Wallet.Balance} />}
          </Col>
        </Col>
        <DashboardReferal />
        <Col
          className="w__Dashboard__Section"
          xl={24}
          lg={24}
          md={24}
          sm={22}
          xs={22}
        >
          {config && config.userID === 14 && (
            <BannerView
              title={`${config.firstName} عزیز، شما میتوانید برنامه کلاس‌های خود را به تقویم گوگل اضافه کنید تا یادآوری کلاس‌ها را علاوه بر پیامک، از طریق Google Calendar در موبایل نیز دریافت نمایید.`}
              action="افزودن برنامه کلاس‌ها به تقویم گوگل"
              onActionClick={() => {
                console.log("click");
                setCalendarClicked(true);
                DashboardReq.calendars()
                  .then((res) => (window.location.href = res.data.Link))
                  .catch((e) => {
                    setCalendarClicked(false);
                  });
              }}
              disabled={calendarClicked}
            />
          )}
        </Col>
        <Col
          className="w__Dashboard__Section"
          xl={24}
          lg={24}
          md={24}
          sm={22}
          xs={22}
        >
          {config && (
            <LessonsList
              theme={theme}
              lang={lang}
              loading={isFetching}
              data={sessions}
            />
          )}
        </Col>
      </>
      <MaterialThemeProvider>
        <ReviewModal
          state={rateState}
          setState={setRateState}
          Session={rateState.session}
        />
      </MaterialThemeProvider>
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => ({
  isFetching: state.dashboard.upcommingSessions.fetching,
  sessions: state.dashboard.upcommingSessions.data,
});

const mapDispatchToProps = (dispatch) => ({
  fetchUpcomingSessions: (role) =>
    dispatch(actions.dashboard.upcommingSessions.fetch(role)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StudentDashboard);
